import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _ListItem from './ListItem.js';
import _CardItem from './CardItem.js';

var _excluded = ["children", "items", "bannerMenuType", "onClick", "theme"];
var _templateObject;
var StyledBannerMenu = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  @media (max-width: 768px) {\n    flex-direction: column;\n  }\n  background: #fff;\n"])));
var BannerMenu = function BannerMenu(_ref) {
  var children = _ref.children,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    bannerMenuType = _ref.bannerMenuType,
    onClick = _ref.onClick,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? themes.secureSite : _ref$theme,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isCardType = function isCardType() {
    if (bannerMenuType === 'list') {
      return false;
    }
    var type = true;
    items.forEach(function (item) {
      if (item.iconName === undefined) {
        type = false;
      }
    });
    return type;
  };
  return /*#__PURE__*/React.createElement(StyledBannerMenu, _extends({
    itemsLength: items.length,
    bannerMenuType: bannerMenuType,
    "data-testid": "banner-menu"
  }, rest), isCardType() ? (items && items).map(function (item, i) {
    return /*#__PURE__*/React.createElement(_CardItem, {
      key: "banner-menu-item-".concat(i),
      index: i,
      url: item.url,
      externalLink: item.externalLink,
      iconName: item.iconName,
      iconSize: item.iconSize,
      text: item.text,
      theme: theme
    });
  }) : (items && items).map(function (item, i) {
    return /*#__PURE__*/React.createElement(_ListItem, {
      key: "banner-menu-item-".concat(i),
      index: i,
      externalLink: item.externalLink,
      url: item.url,
      text: item.text,
      theme: theme
    });
  }), children);
};
var _BannerMenu = withDefaultTheme(BannerMenu);

export default _BannerMenu;
export { BannerMenu };
